//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { request, format } from '@/tools/index.js'
import { isIphonex } from '@runwork/runwork-help'
import DateTime from '../question/modules/date'
import NumberInputSpinner from '@/components/vue-number-input-spinner/src/components/NumberInputSpinner.vue'
export default {
  name: 'settings-page',
  data() {
    return {
      isRW3: undefined, // 平台标志 3.0 true
      isCheck: true,
      rateIsCheck: true,
      limitIsCheck: true,
      rateObj: {
        day: '每天',
        week: '每周',
        month: '每月',
        only: '总共',
      },
      rateList: [
        [
          {
            text: '每天',
            value: 'day',
          },
          {
            text: '每周',
            value: 'week',
          },
        ],
      ],
      limitRateList: [
        [
          {
            text: '每天',
            value: 'day',
          },
          {
            text: '每周',
            value: 'week',
          },
          {
            text: '每月',
            value: 'month',
          },
          {
            text: '总共',
            value: 'only',
          },
        ],
      ],
      item: {
        endTime: '',
        hideAnswerPerson: true,
        limitNumber: 0,
        limitRate: '',
        limitSetting: true,
        rate: '',
        rateSetting: true,
        startTime: '',
        questionnaireId: '',
        timeSetting: true,
      },
      startObj: {
        style: 'datetime',
        title: '开始时间',
        isAnswered: true,
      },
      endObj: {
        style: 'datetime',
        title: '结束时间',
        isAnswered: true,
      },
    }
  },
  components: { DateTime, NumberInputSpinner },
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2() {
      return isIphonex() && this.platform === 2
    },
    questionnaireId() {
      return this.$route.query.questionnaireId
    },
    isAdd() {
      return this.$route.query.isAdd
    },
  },
  async created() {
    const loading = new this.$Loading()
    try {
      await this.$nativeBridgeReady()
      await this.init()
      this.isRW3 = window.h5sdk ? true : false
      loading.close()
    } catch (err) {
      loading.close()
    }
  },
  methods: {
    init() {
      let promiseArr = [this.getSetting()]
      return Promise.all(promiseArr)
    },
    getSetting() {
      const userCode = this.user.ldap
      const params = {
        userCode,
        questionnaireId: this.questionnaireId,
      }
      return request('querySetting', params).then((res) => {
        this.item = res
        if (res) {
          let type = 'yyyy-MM-dd hh:mm'
          let { limitNumber, startTime, endTime } = res
          if (!limitNumber) {
            this.item.limitNumber = 1
          }
          if (startTime) {
            this.item.startTime = format(new Date(startTime), type)
          }
          if (endTime) {
            this.item.endTime = format(new Date(endTime), type)
          }
        }
        this.item.questionnaireId = this.questionnaireId
      })
    },
    closeWebApp() {
      if (this.isAdd) {
        this.$router.push({
          name: 'createItem',
          query: {
            questionnaireId: this.questionnaireId,
          },
        })
      } else {
        this.$router.push('/questionnaire')
      }
    },
    getTips() {
      let uat = 'https://uat.rwork.crc.com.cn/docs/dock9BSwPFosbD5j7navMrJJFlb'
      let prd = 'https://app.rwork.crc.com.cn/docs/dock9YvmLiHRmBlcdpPuYaSDzrc'
      window.location.href =
        process.env.VUE_APP_H5_ENV !== 'production' ? uat : prd
    },
    changeDate(val, type) {
      this.item[type] = val.formatDate ? val.formatDate : ''
    },
    select(type) {
      let list = []
      let title = ''
      switch (type) {
        case 'rate':
          list = this.rateList
          title = '选择通知频率'
          break
        case 'limitRate':
          list = this.limitRateList
          title = '选择周期'
          break
      }
      new this.$Picker({
        data: list,
        value: [],
        title: {
          text: title,
        },
        onOk: (values) => {
          this.item[type] = values[0]
          if (type == 'rate') {
            this.rateIsCheck = true
          } else {
            this.limitIsCheck = true
          }
        },
      })
    },
    clear(type) {
      this.item[type] = ''
    },
    submitFun() {
      let loading = null
      try {
        let {
          endTime,
          limitRate,
          limitSetting,
          rate,
          rateSetting,
          startTime,
          timeSetting,
        } = this.item
        let params = { ...this.item }
        // 校验是否开启时间设置
        if (!timeSetting) {
          delete params.startTime
          delete params.endTime
        } else {
          // 开启设置 开始时间不能大于结束时间
          if (startTime && endTime) {
            let start = new Date(startTime).getTime()
            let end = new Date(endTime).getTime()
            if (start > end) {
              this.isCheck = false
              loading.close()
              return
            }
          }
        }
        if (!limitSetting) {
          delete params.limitRate
          delete params.limitNumber
        } else {
          // 设置开启 不能为空
          if (!limitRate) {
            this.limitIsCheck = false
            loading.close()
            return
          }
        }
        if (!rateSetting) {
          delete params.rate
        } else {
          // 设置开启 不能为空
          if (!rate) {
            this.rateIsCheck = false
            loading.close()
            return
          }
        }
        loading = new this.$Loading()
        return request('setSetting', params).then(() => {
          loading.close()
          this.closeWebApp()
        })
      } catch (err) {
        loading ? loading.close() : ''
      }
    },
  },
}
